module.exports = __webpack_public_path__ + "static/media/nav-cross.aa713708.svg";